import http from '@/services/http';
import apiEndpoints from '@/services/apiEndpoints';

const getDefaultState = () => {
  return {
    menu_accessible: null,
    screen_accessible: null,
    screen_constant: null,
  };
};

const state = getDefaultState();
const getters = {
  menu_accessible (state) {
    return state.menu_accessible;
  },
  screen_accessible (state) {
    return state.screen_accessible;
  },
  screen_constant (state) {
    return state.screen_constant;
  },
};
const mutations = {
  SET_MENU_ACCESSIBLE (state, menu_accessible) {
    state.menu_accessible = menu_accessible;
  },
  SET_SCREEN_ACCESSIBLE (state, screen_accessible) {
    state.screen_accessible = screen_accessible;
  },
  SET_SCREEN_CONSTANT (state, screen_constant) {
    state.screen_constant = screen_constant;
  },
  UNSET_PERMISSIONS (state) {
    state.menu_accessible = null;
    state.screen_accessible = null;
    state.screen_constant = null;
  }
};
const actions = {
  async getPermissions ({ commit, rootState }, payload) {
    if (rootState.auth.user) {
        console.log("getPermissions 開始");
        const resLogin = await http.get(apiEndpoints.get_user_permissions, payload);
        const { status, data } = resLogin;

        if (status) {
          const { menu_accessible, screen_accessible, screen_constant } = data.result;

          commit('SET_MENU_ACCESSIBLE', menu_accessible );
          commit('SET_SCREEN_ACCESSIBLE', screen_accessible );
          commit('SET_SCREEN_CONSTANT', screen_constant );

          // console.log("getPermissions コミット: " + JSON.stringify(data.result));
          console.log("getPermissions コミット: menu: " + menu_accessible.length + " screen: " + screen_accessible.length);

          return {
            status: true,
          };
        } else {
          return {
            status: false,
            errors: data.errors,
            code: data.code,
            message: data.message,
          };
        }
    }
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
